<template>
  <!-- eslint-disable max-len -->
  <ul class="training-sessions scrollbar">

    <li
      v-for="(session, i) in training_sessions"
      :key="i"
      v-tooltip="`Click on the card to see trainer details`"
      class="training-sessions__list-item card"
      @click="handleSessionInfoClick(session)"
    >

      <!-- @click="handleSessionInfoClick(session)" -->
      <div v-if="showProgress(session)" class="progress">
        <div class="training-sessions__header">
          <div class="progress"><div class="header"><span class="section-title">Progress</span></div></div>
        </div>
        <div class="body _separator">
          <TaskStatusBars :key="session.id" :task="session.docker_task" />
        </div>
      </div>
      <div class="statistics">
        <div class="training-sessions__header">
          <div class="statistics">
            <div class="header">
              <div class="left">
                <div class="icon-container">
                  <v-icon v-if="isCloud(session)" v-tooltip="`Cloud Hosted Training Session`">mdi-cloud</v-icon>
                  <v-icon v-if="isUserManaged(session)" v-tooltip="`User Managed Session`">mdi-laptop</v-icon>
                  <v-icon v-if="isKubernetes(session)" v-tooltip="`Kubernetes Manages Session`">mdi-kubernetes</v-icon>
                  <v-icon ></v-icon>
                  <v-icon v-if="isDetect(session)" v-tooltip="`Detection`">mdi-account-box-multiple-outline</v-icon>
                  <v-icon v-if="isSegment(session)" v-tooltip="`Segmentation`">mdi-hexagon-multiple</v-icon>
                  <v-icon v-if="isFusion(session)" v-tooltip="`Fusion`">mdi-radar</v-icon>
                  
                </div>

         
                <!-- <span class="section-title">{{ manageType(session) }}</span> -->
              </div>
              <div v-if="!hasMetrics(session) && !hasResults(session)" class="right">
                <div class="icon-container">
                  <IconButton
                    v-tooltip="`Refresh training session`"
                    class="icon refresh-icon"
                    :icon="'refresh'"
                    :width="20"
                    :height="20"
                    :type="'click'"
                    @click.stop="handleRefresh(session)"
                  />
                  <IconButton
                    v-tooltip="`Clone Training Session`"
                    class="icon maximize-icon"
                    :icon="'copy'"
                    :width="20"
                    :height="20"
                    :type="'click'"
                    @click.stop="cloneTask(session)"
                  />
                  <IconButton
                    v-tooltip="`View charts for training session`"
                    class="icon analytics-icon"
                    :icon="'analytics'"
                    :width="22"
                    :height="22"
                    :type="'click'"
                    @click.stop="handleShowChartsClick(session)"
                  />
                  <IconButton
                    v-if="permissions && permissions.trainer_write"
                    v-tooltip="`Terminate training session. This will stop training, but you can still view train artifacts`"
                    class="icon stop-icon"
                    :icon="'stop_circle'"
                    :width="22"
                    :height="22"
                    :type="'click'"
                    @click.stop="terminateTask(session)"
                  />
                  <IconButton
                    v-if="permissions && permissions.trainer_write"
                    v-tooltip="`Move training session to recycle bin`"
                    class="icon delete delete-icon"
                    :icon="'trash'"
                    :width="22"
                    :height="22"
                    :type="'click'"
                    @click.stop="deleteTask(session)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="body scrollbar" :class="{ '_separator': hasMetrics(session) || hasResults(session)}">
          <div class="body__header">
            <div class="owner-id-display">
              <UserIcon
                :user="userList?.find((e) => e.username === session.docker_task.username)"
                :size="'32px'"
              />
              <EncodedIdField
                :id="session.id"
                :type="'trainer'"
                :hideLabel="false"
              />
              <div val-status class="status-col">
                <span v-if="sessionStatusList[session.id]?.toLowerCase().includes('complete')" class="status-tag _complete"><div class="status-icon">&#x2713;</div>Complete</span>
                <span v-else-if="sessionStatusList[session.id]?.toLowerCase().includes('error')" class="status-tag _error"><div class="status-icon">&#x2716;</div>Error</span>
                <span v-else-if="sessionStatusList[session.id]?.toLowerCase().includes('terminate')" class="status-tag _warning"><div class="status-icon">&#x21;</div>Terminated</span>
                <span v-else-if="sessionStatusList[session.id]" class="status-tag _running"><div class="running-icon" />
                  {{ String(sessionStatusList[session.id]).charAt(0).toUpperCase() + String(sessionStatusList[session.id]).slice(1) }}
                </span>
              </div>
            </div>
            <div class="name-display">
              <div
                v-tooltip="session.name ? session.name : 'Unknown'"
                class="description"
              >
                {{ session.name ? session.name : "Unknown" }}
              </div>
              <div
                v-if="session && session.description"
                v-tooltip="session.description"
                class="value"
              >
                {{ session.description }}
              </div>
            </div>
          </div>
          <hr>
          <div class="body__grid">
            <div class="body__grid-field">
              <div class="description">Dataset</div>
              <div
                v-tooltip="session.params.trainer_params ? session.params.trainer_params['dataset_name'] : 'Unknown'"
                class="value"
              >
                {{ session.params.trainer_params ? session.params.trainer_params['dataset_name'] : 'Unknown' }}
              </div>
            </div>
            <div class="body__grid-field" v-if="session.docker_task">
              <div class="description">Start Date</div>
              <div class="value"><span> {{ formatTime(session.docker_task.date) }}</span></div>
            </div>
            <div class="body__grid-field" v-if="session.docker_task && getEndTime(session.docker_task)">
              <div class="description">Duration</div>
              <div class="value"><span class="duration">{{ getEndTime(session.docker_task) }}</span></div>
            </div>
             <div class="body__grid-field" v-if="session.model">
              <div class="description">Model</div>
              <div class="value"><span >{{ session.model }}</span></div>
            </div>
            <!-- Type can be in model name or model size -->
            <div class="body__grid-field" v-if="session.params?.model_params?.model?.model_size">
              <div class="description">Type</div>
              <div class="value"><span >{{ session.params?.model_params?.model?.model_size }}</span></div>
            </div>
            <div class="body__grid-field" v-if="session.params?.model_params?.model?.model_name">
              <div class="description">Type</div>
              <div class="value"><span >{{ session.params?.model_params?.model?.model_name }}</span></div>
            </div>
            
            <div class="body__grid-field" v-if="session.params?.model_params?.input?.size ">
              <div class="description">Size</div>
              <div class="value"><span >{{ session.params?.model_params?.input?.size }}</span></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="hasMetrics(session)" class="metrics">
        <div class="training-sessions__header">
          <div class="metrics">
            <div class="header">
              <div class="left">
                <span class="section-title">Metrics</span>
              </div>
              <div v-if="!hasResults(session)" class="right">
                <div class="icon-container">
                  <IconButton
                    v-tooltip="`Refresh training session ${session.name}`"
                    class="icon refresh-icon"
                    :icon="'refresh'"
                    :width="20"
                    :height="20"
                    :type="'click'"
                    @click.stop="handleRefresh(session)"
                  />
                  <IconButton
                    v-tooltip="`Clone Training Session`"
                    class="icon maximize-icon"
                    :icon="'copy'"
                    :width="20"
                    :height="20"
                    :type="'click'"
                    @click.stop="cloneTask(session)"
                  />
                  <IconButton
                    v-tooltip="`View charts for training session`"
                    class="icon analytics-icon"
                    :icon="'analytics'"
                    :width="22"
                    :height="22"
                    :type="'click'"
                    @click.stop="handleShowChartsClick(session)"
                  />
                  <IconButton
                    v-if="permissions && permissions.trainer_write"
                    v-tooltip="`Terminate training session. This will stop training, but you can still view train artifacts`"
                    class="icon stop-icon"
                    :icon="'stop_circle'"
                    :width="22"
                    :height="22"
                    :type="'click'"
                    @click.stop="terminateTask(session)"
                  />
                  <IconButton
                    v-if="permissions && permissions.trainer_write"
                    v-tooltip="`Move training session to recycle bin`"
                    class="icon delete delete-icon"
                    :icon="'trash'"
                    :width="22"
                    :height="22"
                    :type="'click'"
                    @click.stop="deleteTask(session)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="body _separator">
          <div class="body__grid scrollbar">
            <div v-for="(metricVal, metric) in session.metrics" :key="metric" class="body__grid-field">
              <div class="description">{{ metric }}</div>
              <div v-tooltip="metricVal" class="value">{{ metricVal }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="hasResults(session)" class="charts">
        <div class="training-sessions__header">
          <div class="charts">
            <div class="header">
              <div class="left">
                <span class="section-title">Result</span>
              </div>
              <div class="right">
                <div class="icon-container">
                  <IconButton
                    v-tooltip="`Refresh training session`"
                    class="icon refresh-icon"
                    :icon="'refresh'"
                    :width="20"
                    :height="20"
                    :type="'click'"
                    @click.stop="handleRefresh(session)"
                  />
                  <IconButton
                    v-tooltip="`Clone Training Session`"
                    class="icon maximize-icon"
                    :icon="'copy'"
                    :width="20"
                    :height="20"
                    :type="'click'"
                    @click.stop="cloneTask(session)"
                  />
                  <IconButton
                    v-tooltip="`View charts for training session`"
                    class="icon analytics-icon"
                    :icon="'analytics'"
                    :width="22"
                    :height="22"
                    :type="'click'"
                    @click.stop="handleShowChartsClick(session)"
                  />
                  <IconButton
                    v-if="permissions && permissions.trainer_write"
                    v-tooltip="`Terminate training session. This will stop training, but you can still view train artifacts`"
                    class="icon stop-icon"
                    :icon="'stop_circle'"
                    :width="22"
                    :height="22"
                    :type="'click'"
                    @click.stop="terminateTask(session)"
                  />
                  <IconButton
                    v-if="permissions && permissions.trainer_write"
                    v-tooltip="`Move training session to recycle bin`"
                    class="icon delete delete-icon"
                    :icon="'trash'"
                    :width="22"
                    :height="22"
                    :type="'click'"
                    @click.stop="deleteTask(session)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="training-chart-container">
          <TrainingChartSingle
            :name="session.results.name"
            :labels="session.results.labels"
            :series="session.results.series"
            @chart-clicked="chartZoomHandler(session.results.name)"
          />
        </div>
      </div>
    </li>
  </ul>
</template>
<script>

import TrainingChartSingle from '@/components/TrainerComponent/TrainerExperimentAndSessions/TrainingChartSingle';
import IconButton from '@/components/IconButton.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import EncodedIdField from '@/components/EncodedIdField.vue';
import TaskStatusBars from '@/components/TaskStatusBars.vue';
import UserIcon from '@/components/UserIcon.vue';
import { Controls } from 'three';

export default {
  name: "TrainerCard",
  components: {
    IconButton,
    SVGIcon,
    UserIcon,
    EncodedIdField,
    TaskStatusBars,
    TrainingChartSingle,
  },
  props: {
    training_sessions: {
      type: Object,
      default: () => {},
    },
    currentProject: {
      type: Object,
      default: () => {},
    },
    permissions: {
      type: Object,
      default: () => {},
    },

  },
  emits: ['clone-training-session', 'show-trainer-details', 'create-trainer-session', 'info-clicked', 'charts-clicked', 'analytics-clicked', 'terminate-session', 'delete-trainer', 'delete-session', 'edit-trainer', 'refresh-session'],
  data() {
    return {
      dsConn: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      show_menu: false,
      hiddenProgress: [],
      sessionStatusList: {},
    };
  },
  computed: {
    userList() {
      return this.$store.state.user.userList;
    },
  },
  watch: {
    training_sessions: {
      deep: true,
      handler() {
        if (this.training_sessions) {
          this.training_sessions.forEach((session) => {
            this.getStatus(session);
          });
        }
      },
    },
  },
  mounted() {
    if (this.training_sessions) {
      this.training_sessions.forEach((session) => {
        this.getStatus(session);
      });
    }
  },
  methods: {
    isDetect(session) {return (session.params?.model_params?.model?.detection);},
    isSegment(session) {return (session.params?.model_params?.model?.segmentation);},
    isFusion(session) {return (session.trainer_params?.task=='fusion');},
    isCloud(session) {return (session.docker_task?.manage_type=='' || session.docker_task?.manage_type=='aws' );},
    isUserManaged(session) {return (session.docker_task.manage_type=='user');},
    isKubernetes(session) {return (session.docker_task.manage_type=='kubernetes');},

    showProgress(v) {
      if (!v) return false;
      const task = v.docker_task;
      if (task.status.toLowerCase().includes('complete')) return false;
      if (task.status.toLowerCase().includes('error')) return false;
      if (task.status.toLowerCase().includes('terminated')) return false;
      if (task.data.length < 4) return false;
      return true;
    },
    manageType(v) {
      if (!v) return "-";
      const type = v.docker_task.manage_type;
      if (type == '') return "Cloud";
      if (type == 'aws') return "Cloud";
      if (type == 'user') return "User Managed";
      if (type == 'kubernetes') return "Kubernetes";
      return "--";
    },
    hasMetrics(session) {
      // return session && session.metrics && Object.keys(session.metrics).length > 0;
      return false;
    },
    hasResults(session) {
      return session && session.results && Object.keys(session.results).length > 0;
    },
    toggleHideProgress(v, id) {
      const index = this.hiddenProgress.indexOf(id);
      if (v) {
        this.hiddenProgress.push(id); // Add if not
      } else {
        if (index > -1) {
          this.hiddenProgress.splice(index, 1); // Remove if exists
        }
      }
    },
    handleSessionInfoClick(session) {
      this.$emit("info-clicked", session);
    },
    handleShowChartsClick(session) {
      this.$emit('charts-clicked', session);
    },
    getStatus(session) {
      this.sessionStatusList[session.id] = session.docker_task.status;
    },
    getMessage(session) {
      if (session && session.docker_task) {
        return session.docker_task.message;
      }
      return null;
    },
    getCount(session) {
      if (session && session.docker_task) {
        return session.docker_task.count;
      }
      return null;
    },
    getTotal(session) {
      if (session && session.docker_task) {
        return session.docker_task.total;
      }
      return null;
    },
    getEndTime(docker_task) {
      if (docker_task.end_date !== "0001-01-01T00:00:00Z" && docker_task.date !== "0001-01-01T00:00:00Z") {
        const msDiff = new Date(docker_task.end_date) - new Date(docker_task.date);
        const minutes = Math.floor(msDiff / (1000 * 60)) % 60;
        const hours = Math.floor(msDiff / (1000 * 60 * 60)) % 24;
        const days = Math.floor(msDiff / (1000 * 60 * 60 * 24));
        const result = [];
        if (days > 0) result.push(`${days} day${days > 1 ? 's' : ''}`);
        if (hours > 0) result.push(`${hours} hr${hours > 1 ? 's' : ''}`);
        if (minutes > 0) result.push(`${minutes} min${minutes > 1 ? 's' : ''}`);
        return result.join(" ") || "0 mins";
      } else if (docker_task.end_date === "0001-01-01T00:00:00Z" && docker_task.date !== "0001-01-01T00:00:00Z") {
        const msDiff = Date.now() - new Date(docker_task.date);
        const minutes = Math.floor(msDiff / (1000 * 60)) % 60;
        const hours = Math.floor(msDiff / (1000 * 60 * 60)) % 24;
        const days = Math.floor(msDiff / (1000 * 60 * 60 * 24));
        const result = [];
        if (days > 0) result.push(`${days} day${days > 1 ? 's' : ''}`);
        if (hours > 0) result.push(`${hours} hr${hours > 1 ? 's' : ''}`);
        if (minutes > 0) result.push(`${minutes} min${minutes > 1 ? 's' : ''}`);
        return result.join(" ") || "0 mins";
      } else {
        return null;
      }
    },
    formatTime(str) {
      return `${new Date(str).toLocaleTimeString('default', {
        year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true,
      })}`;
    },
    terminateTask(session) {
      this.$emit('terminate-session', session);
    },
    deleteTask(session) {
      this.$emit('delete-session', session);
    },
    cloneTask(session) {
      this.$emit('clone-training-session', session);
    },
    handleDeleteTrainer() {
      this.$emit('delete-trainer');
    },
    handleRefresh(session) {
      this.$emit('refresh-session', session);
    },
    parseMPKShape(shape) {
      if (!shape) {
        return "";
      }
      const split = shape.split(",");
      return [split[1], split[0]].join(",");
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  position: relative;
  height: fit-content;
  padding: 0;
  margin: 0;
  text-align: left;
  border-radius: 8px;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);
}

.actions{
  margin: 10px 20px;
  display: flex;
  flex-direction: column;

  &__header{
    display: flex;
    flex-direction: row;
    .left{
      width: 40%;
      max-width: 40%;

      span{
        font-weight: bold;
        font-size: 1.15rem;
      }
    }
    .right{
      display: flex;
      flex-direction: row;
      width: 60%;
      max-width: 60%;
      gap: 12px;
      align-items: center;
      justify-content: flex-end;
    }

    .button {
      background: white;
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 26px;
      padding: 0;
      box-shadow: 1px 2px 4px 1px rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(0, 0, 0, 1);
      padding: 4px 8px;
      gap: 2px;
      width: fit-content;

      @include themify() {
        color: themed('body-text-color')
      }

      &:hover {
        background: rgba(var(--color-primary-100-rgb), 0.5);
      }
    }

    .delete {
      background: #b60000;
      color: #f6f7f8 !important;
    }
  }
}

.trainer-menu {
  list-style-type: none;
  margin: 0;
  padding: 0;
  min-width: 100px;
}

.training-sessions {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  &__list-item {
    display: flex;
    flex-direction: row;
    border-radius: 8px;
    cursor: pointer;
  }

  &__header {
    display: flex;
    flex-direction: row;
    padding: 4px 16px;
    background: var(--gray-200);
    height: 32px;
  }

  .progress {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 350px;
    // width: min(30%, 400px);
    // max-width: min(30%, 400px);
  }
  .statistics {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 350px;
    // width: min(30%, 500px);
    // max-width: min(40%, 500px);
  }
  .metrics {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 300px;
    max-width: 600px;
    // width: min(20%, 500px);
    // max-width: min(40%, 500px);
  }
  .charts {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 300px;
    max-width: 600px;
  }

  .left {
    width: 50%;
    min-width: 50%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .right {
    width: 50%;
    min-width: 50%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 100%;
}

.body {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  padding: 10px;
  overflow: auto;

  &__header{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    .owner-id-display {
      display: flex;
      flex-direction: row;
      gap: 10px;
      align-items: center;
      width: 100%;

      .labels-container {
        flex: 1
      }
    }

    .name-display {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .description {
        font-size: 0.9rem;
        font-weight: 600;
        color: var(--body-text-color);
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .value {
        font-size: 0.8rem;
        font-weight: 600;
        color: var(--body-text-color-secondary);
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

  }

  &__grid-field {
    display: flex;
    flex-direction: row;
    margin-top: 0px;
  }

  &__grid {
    display: block;

    .description {
      font-size: 0.9rem;
      font-weight: 600;
      color: var(--body-text-color);
      width: 100px;
      min-width: 100px;
    }
    .value {
      font-size: 0.9rem;
      font-weight: 500;
      color: var(--body-text-color-secondary);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  &._separator::after {
    content: "";
    position: absolute;
    right: 0;
    top: 5%;
    bottom: 5%;
    width: 1px;
    background-color: #9a9ca2;
  }
}

.icon-container {
  display: flex;
  align-items: center;
  margin-left: 10px;
  @include themify() {
    color: themed('body-text-color-secondary');
  }
  .icon + .icon {
    margin-left: 14px;
  }
  .icon-label {
    cursor: arrow;
  }
}

.footer {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
}

.icon {
  @include themify() {
    color: themed('body-text-color-secondary');
  }
}

.icon:hover {
  @include themify() {
    color: themed('color-primary');
    background: themed('icon-hover-color');
    border-radius: 100%;
    box-shadow: 0 0 0 4px themed('icon-hover-color');
  }
}

.icon.delete:hover {
  color: var(--color-error)
}

.status-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  min-width: 100px;
  border-radius: 18px;
  padding: 4px 6px;
  line-height: 1;
  font-size: 0.625rem;
  font-weight: 700;
  white-space: nowrap;
  border: 2px solid;
  box-shadow: 0px 0px 1px rgb(0 0 0 / 25%), 0px 1px 4px rgb(0 0 0 / 25%);
  @include themify() {
    color: themed('color-black');
  }

  &._complete {
    @include themify() {
      color: themed('color-status-complete');
      background: themed('color-status-complete-background');
    }
  }
  &._running {
    @include themify() {
      color: themed('color-status-running');
      background: themed('color-status-running-background');
    }
  }
  &._error {
    @include themify() {
      color: themed('color-status-error');
      background: themed('color-status-error-background');
    }
  }

  &._warning {
    @include themify() {
      color: themed('color-status-warning');
      background: themed('color-status-warning-background');
    }
  }

  .running-icon {
    color: inherit;
    width: 4px;
    height: 4px;
    border: solid 4px;
    border-radius: 4px;
    margin-right: 4px;
  }

  .status-icon {
    color: inherit;
    margin-right: 4px;
  }
}

.vertical-separator {
  width: 1px;
  height: 80%;
  background-color: #9a9ca2;

  margin-top: auto;
  margin-bottom: auto
}

.trainer-id-field {
  margin-right: 20px;
}

:deep() {
  .v-expansion-panel__shadow {
    box-shadow: none !important;
  }
}

.section-title {
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 1rem;
  font-weight: 700;
  color: var(--body-text-color-heading);
  letter-spacing: 0.025em;
  gap: 6px;
}

.training-sessions-empty {
  display: flex;
  flex-direction: column;
  height: 150px;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: bold;
  border: solid 1px black;
  border-radius: 8px;
  @include themify() {
    background: radial-gradient(circle, rgba($color-primary-300, 0.075) 50%, rgba(var(--color-primary-rgb), 0.125) 100%);
  }

  span {
    padding: 16px;
    text-align: center;
  }
}

.training-chart-container {
  padding: 5px;
  height: 100%;
  overflow: hidden;
}

</style>
